import { call, take, put } from 'redux-saga/effects';
import { post } from '../../utils/api';
import settings from '../../utils/settings';
import { constructQueryString } from '../../utils/helper';

import {
  GET_USER_FEATURES_SET_REQUEST,
  GET_USER_FEATURES_SET_SUCCESS,
  GET_USER_FEATURES_SET_FAILURE
} from './constants';
import _ from './utils';

export function* getUserFeaturesSet() {
  while (true) {
    const request = yield take(GET_USER_FEATURES_SET_REQUEST);
    try {
      let response;
      let urlParameters = constructQueryString({
        decision_reason: 'A_B testing',
        'input[email]': _.get(request, 'payload.email'),
        'input[app_version]': '3.4.0'
      });

      const url = settings.getApiUrl(`decision_rule/feature_level_applicability.json?${urlParameters}`);
      response = yield call(post, {
        url,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      });

      if (response.success) {
        yield put({
          type: GET_USER_FEATURES_SET_SUCCESS,
          data: response.result
        });
      } else {
        yield put({
          type: GET_USER_FEATURES_SET_FAILURE,
          error: response.result.message || response.result.messages
        });
      }
    } catch (error) {
      yield put({ type: GET_USER_FEATURES_SET_FAILURE, error: error });
    }
  }
}
